export default __webpack_public_path__ + "static/media/girl_modal.a0057fe2.svg";